export default __webpack_public_path__ + "static/media/hospital.5b0b0417.svg";